<!-- 待分配客户列表 -->
<template>
  <div class="threeLevelMain">
    <!-- 头部查询区域 -->
    <!-- <div class="queryBox clearfix">
          <div class="query_row">
            <div class="btn_box">
            </div>
          </div>
      </div> -->
    <!-- 内容 -->
    <tablePageComp
      :columnsList="columnsList"
      :dataList="dataList"
      :orderNumConfig="{
        fixed: true,
      }"
      :totalCount="totalCount"
      :getDataConfig="dataQueryFunc()"
      :updateDataTag="updateDataTag"
    >
      <el-table-column slot="handle" label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-tooltip placement="top" content="指派">
            <el-button
              type="warning"
              size="mini"
              @click="openAssignDia(scope.row)"
            >
              <!-- icon="iconfont iconzhipai1" -->
              指派
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column slot="NowAssigned" label="当前指派信息" align="center">
        <template slot-scope="scope">
          店长：<span class="fontColor_theme2" style="margin-right: 20px;">{{
            scope.row.assign_name
          }}</span>

          组长：<span class="fontColor_theme2">{{
            scope.row.assign_name_leader
          }}</span>
        </template>
      </el-table-column>
    </tablePageComp>

    <el-dialog
      :visible.sync="assignVis"
      title="离职员工所属客户信息变更"
      width="500px"
    >
      <el-form label-width="100px">
        <el-form-item label="品牌名:">
          <span style="font-size: 14px;">{{ assignForm.brand_name }}</span>
        </el-form-item>
        <el-form-item label="店长">
          <el-select v-model="assignForm.assign_id" filterable>
            <el-option
              v-for="item in operatePersonOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="组长">
          <el-select v-model="assignForm.assign_id_leader" filterable>
            <el-option
              v-for="item in groupLeaderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售">
          <el-select v-model="assignForm.sale_id" filterable>
            <el-option
              v-for="item in salePersonOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="assignVis = false" :loading="btnLoad"
          >取消</el-button
        >
        <el-button
          size="small"
          @click="subHandle"
          :loading="btnLoad"
          type="primary"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
import utils from "@/libs/utils.js";
export default {
  data() {
    let d = utils.sessionGetStore("department");

    return {
      department: d,

      //表格内容相关
      dataList: [], //表格数据列表
      columnsList: [
        {
          slotName: "handle",
          label: "handle",
        },
        {
          label: "公司名",
          prop: "corporate_name",
        },
        {
          label: "品牌名",
          prop: "brand_name",
        },
        {
          label: "当前所属销售",
          prop: "sale_name",
        },
        {
          label: "当前指派信息",
          slotName: "NowAssigned",
        },
      ],
      updateDataTag: false,
      // 数据总条数
      totalCount: 0,
      userId: "", //用户id
      userName: "", //用户名
      assignVis: false,
      assignForm: {
        id: "", // id
        customer_id: "", // 客户id   指派销售传单条id，指派店长传客户id
        assign_id: "",
        assign_id_leader: "",
        sale_id: "",
        name: "", // 公司名
        work_order_id: "", // work_order_id
        brand_name: "",
      },
      btnLoad: false,
    };
  },
  computed: {
    salePersonOptions() {
      return this.$store.getters.salePersonOptions;
    },
    groupLeaderOptions() {
      return this.$store.getters.groupLeaderOptions;
    },
    operatePersonOptions() {
      return this.$store.getters.operatePersonOptions;
    },
  },
  created() {
    //获取用户id
    this.userId = utils.sessionGetStore("user_id");
    this.userName = utils.sessionGetStore("user_name");

    //  花花、怒发及技术部可访问
    if (this.userId != 2 && this.userId != 1 && this.department != 7) {
      this.$message({ type: "warning", message: "暂无权访问" });
      return;
    }
  },

  methods: {
    subHandle() {
      let paramObj = JSON.parse(JSON.stringify(this.assignForm)),
        param_sale = JSON.parse(JSON.stringify(this.assignForm));
      delete paramObj.brand_name;
      delete param_sale.brand_name;
      // delete param_sale.customer_id // 梓龙让打开 2023.03.22
      paramObj.up_user = this.userId;
      param_sale.up_user = this.userId;
      this.btnLoad = true;
      let a1 = new Promise((resolve, reject) => {
        // 指派运营
        paramObj.state = "1"; // 指派状态
        paramObj.id = paramObj.customer_id;
        delete paramObj.customer_id;
        api
          .customerAssign(paramObj)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject();
          });
      });
      let a2 = new Promise((resolve, reject) => {
        api
          .saleAssign(param_sale)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            console.log(error);
            reject();
          });
      });

      Promise.all([a1, a2])
        .then((res) => {
          // console.log(res)
          this.btnLoad = false;
          this.updateDataTag = !this.updateDataTag;
          this.assignVis = false;
          utils.notificationInfo("消息", "信息已变更", "success");
        })
        .catch((error) => {
          console.log(error);
          this.btnLoad = false;
          this.$message.error("提交失败");
        });
    },
    openAssignDia(param) {
      this.assignVis = true;
      this.resetForm();
      Object.keys(this.assignForm).forEach((key) => {
        if (key == "name") {
          this.assignForm.name = param.corporate_name;
        } else {
          this.assignForm[key] = param[key];
        }
      });
    },
    resetForm() {
      Object.keys(this.assignForm).forEach((key) => {
        this.assignForm.name = "";
      });
    },
    dataQueryFunc() {
      //查询条件
      let paramObj = {};
      return {
        apiName: "toBeAssignedFunc",
        paramObj,
        success: function(response, callBack) {
          let records = response.data.data.list;
          let arr = [];
          for (let i = 0; i < records.length; i++) {
            let obj = records[i];
            let standardObj = {};
            for (let key in standardObj) {
              if (obj[key] == null || obj[key] == undefined) {
                obj[key] = "";
              }
            }
            arr.push(obj);
          }

          // 数据列表---更新
          this.dataList = arr;
          // 数据总条数---更新
          this.totalCount = response.data.data.totalCount; //接口返回的数据总条数

          // 回调函数
          if (callBack) {
            callBack();
          }
        }.bind(this),
        failed: function(error, callBack) {
          // 回调函数
          if (callBack) {
            callBack();
          }
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.threeLevelMain {
  .queryBox {
    margin-bottom: 2px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    position: relative;

    // 实际服务金额
    .cooperation_amount {
      display: flex;
      align-items: center;
      justify-content: center;
      > div {
        margin: 0 !important;
      }
    }
    .activeBtn {
      position: absolute;
      top: 15px;
      right: 50px;
    }
  }

  .tabComtent {
    background: #fff;
    height: 100%;
  }

  .totalAmount {
    position: absolute;
    width: 300px;
    // background: red;
    bottom: 25px;
    right: 20px;

    > p {
      font-size: 16px;
      font-weight: 500;
      > span {
        font-size: 16px;
        color: #409eff;
      }
    }
  }
}

.demo-ruleForm {
  > h3 {
    font-size: 16px;
    text-align: center;
    padding: 20px 0;
    color: #409eff;
    letter-spacing: 1px;
  }
  > div {
    padding: 20px;
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
    .formItems {
      width: 30%;
    }
  }
}
</style>
